import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-subprocessors-cz',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './subprocessors-cz.component.html',
  styleUrls: ['./subprocessors.component.scss'],
})
export class SubprocessorsCzComponent {
  @Input() lastUpdated!: string;
  @Input() version!: string;
  @Input() supportEmail!: string;

  subprocessors = [
    {
      name: 'Firebase (Google)',
      purpose: 'User authentication (Firebase Auth)',
      dataTypes: ['Email addresses, identifiers, login credentials'],
    },
    {
      name: 'AWS (S3, Parameter Store, Secrets Manager, IAM)',
      purpose: 'File storage, secure configuration management, and infrastructure access control',
      dataTypes: [
        'Documents containing personal data (e.g. PDFs, images)',
        'Configuration data, credentials (may include tokens linked to user actions)',
      ],
      note: 'While some components do not directly process end-user data, they are part of the infrastructure stack and are therefore considered subprocessors.',
    },
    {
      name: 'Google API (Gmail & Calendar)',
      purpose: 'Gmail API: Sending and receiving emails with candidates. Google Calendar API: Scheduling interviews with candidates during the recruitment process',
      dataTypes: ['Email addresses, communication content, scheduled events'],
    },
    {
      name: 'Sentry',
      purpose: 'Error monitoring and logging',
      dataTypes: ['May potentially include metadata on user activity, user IDs for error tracing'],
    },
    {
      name: 'OpenAI API',
      purpose: 'Language model embeddings generation and structured data extraction',
      dataTypes: ['Raw or tokenized text (including job descriptions or pseudonymized candidate CVs). Returns JSON with embeddings or structured data'],
    },
    {
      name: 'MistralAI API',
      purpose: 'Language model embeddings generation',
      dataTypes: ['Raw or tokenized text (job descriptions or candidate data). Returns embeddings vector'],
    },
    {
      name: 'Vercel',
      purpose: 'Frontend deployment',
      dataTypes: ['Potentially static content of the application, which may retrieve data via REST API'],
    },
  ];
}
